export const visit = (vm, at) => {
at({ "lt": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} i\u0161 {{totalBytes}}" }, "fileSizeLimit": "Failas negali b\u016Bti didesnis nei {{size}}", "screenCapture": "Ekrano nuotrauka" } } });
};